<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    withDefaults(defineProps<{ label?: string }>(), { label: "Typ" });

    const fetchAktivitetstyper = async ({ query }: { query?: string } = {}) => {
        const store = useStore();
        try {
            const params: { namn?: string } = {};
            if (query) params.namn = query;

            const { subsetName } = await store.dispatch("skreg/aktivitetstyper/fetchAktivitetstyper", {
                filterParams: params,
            });
            const items = store.getters["skreg/aktivitetstyper/aktivitetstypSubset"]({ subsetName, limit: 0 });

            return items.map((typ: { id: string; namn: string }) => ({ value: typ.id, label: typ.namn }));
        } catch {
            flashWarning("Kunde inte hämta aktivitetstyper");
        }
    };
</script>

<template>
    <KAutocomplete
        name="aktivitetstyp"
        :label="label"
        v-bind="$attrs"
        :options="fetchAktivitetstyper"
        :onSearch="fetchAktivitetstyper"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
